"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.absurdInPractice = exports.absurd = exports.AbsurdError = void 0;
class AbsurdError extends Error {
    constructor(value, message) {
        super(message ||
            'Should not be able to reach this point; the value attached to this error should not be possible. ');
        this.name = 'AbsurdError';
        this.value = value;
    }
}
exports.AbsurdError = AbsurdError;
function absurd(value, message) {
    throw new AbsurdError(value, message);
}
exports.absurd = absurd;
function absurdInPractice(value, message) {
    throw new AbsurdError(value, message);
}
exports.absurdInPractice = absurdInPractice;
//# sourceMappingURL=absurd.js.map